import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-drop-fill text-lg md:text-xl"></i>
            </div>
            <span
              className={`font-heading text-xl md:text-2xl font-bold tracking-wide whitespace-nowrap transition-colors ${
                isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
              }`}
            >
              鲍鱼盒子
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                isScrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
              } ${location.pathname === '/' ? 'text-primary-500' : ''}`}
            >
              首页
            </Link>
            <Link
              to="/categories"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                isScrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
              } ${location.pathname.startsWith('/categories') ? 'text-primary-500' : ''}`}
            >
              产品分类
            </Link>
            <Link
              to="/articles"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                isScrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
              } ${location.pathname.startsWith('/articles') ? 'text-primary-500' : ''}`}
            >
              鲍鱼百科
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                isScrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
              } ${location.pathname === '/about' ? 'text-primary-500' : ''}`}
            >
              关于我们
            </Link>
            <a
              href="tel:400-888-9999"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30 backdrop-blur-sm'
              }`}
            >
              <i className="ri-phone-line"></i>
              400-888-9999
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-200 py-4 bg-background-50">
            <div className="flex flex-col gap-3">
              <Link to="/" className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors">首页</Link>
              <Link to="/categories" className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors">产品分类</Link>
              <Link to="/articles" className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors">鲍鱼百科</Link>
              <Link to="/about" className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors">关于我们</Link>
              <a href="tel:400-888-9999" className="mx-4 mt-2 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line"></i>
                400-888-9999
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}